module.exports = __webpack_public_path__ + "img/stemImg1@2x.8159ef93.jpg";